<template>
  <div>
    <h2>Soluções Personalizadas</h2>
    <p>Se as soluções em sistemas informatizados disponíveis não se encaixam nas suas necessidades, podemos adequar o sistema Pergamin ou desenvolver um sistema personalizado para você.</p>
    <p>Entre as funcionalidades possíveis para o produto personalizado, nas quais possuímos experiência extensiva, se destacam:</p>
    <ul>
      <li>Contabilidade e financeiro</li>
      <li>Emissão de notas fiscais</li>
      <li>Proteção e segurança de bancos de dados</li>
      <li>Serviços on-line para clientes, como marcação de horário</li>
      <li>Comunicação com o cliente pelo envio de e-mails através do sistema</li>
      <li>Comunicação interna entre colaboradores para controle de atividades</li>
      <li>Integração com equipamento médico</li>
      <li>Controle de estoque</li>
      <li>Design e desenvolvimento de uma home page na internet para a sua empresa*</li>
      </ul>
      <p>Para orçamentos e mais informações,  <router-link to="/contato" class="linkbold">contate-nos.</router-link></p>
    
    <p
      class="observ"
    >* a identidade visual (nome da empresa, marca, logotipo) é responsabilidade do cliente da Lucchese Computação e Estatística.</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
.observ {
  font-size: 0.7rem;
}

</style>